import { FunctionComponent, useContext } from 'react';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import LocationFormField from '../location-form-field';
import { GeneralConfigContext } from '../../general-config-provider';
import { splitField, splitFieldForms } from '../../../shared/utils';

type TouristActivityPreviewProps = {
  detailData: any;
};

export const TouristActivityPreview: FunctionComponent<
  TouristActivityPreviewProps
> = ({ detailData = {} }) => {
  const { generalConfig } = useContext(GeneralConfigContext);

  return (
    <div className={serviceDetailBaseStyles.detailContainer}>
      <LocationFormField value={detailData.ubicacion} viewOnly={true} />

      <p>
        Tipo de actividad:{' '}
        <strong>
          {
            generalConfig?.tipo_actividad.find(
              (type) => type.id_tipo_actividad === detailData.id_tipo_actividad
            ).nombre
          }
        </strong>
      </p>

      <p>{detailData.descripcion_ficha_tecnica}</p>

      {splitFieldForms(detailData.recomendaciones).spanish != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>Recomendaciones de seguridad</p>
          <p>{splitFieldForms(detailData.recomendaciones).spanish}</p>
        </div>
      )}

      {splitFieldForms(detailData.recomendaciones).spanish != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>Recomendaciones de seguridad</p>
          <p>{splitFieldForms(detailData.recomendaciones).spanish}</p>
        </div>
      )}

      {splitFieldForms(detailData.reglamento).spanish != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>Restricciones</p>
          <p>{splitFieldForms(detailData.reglamento).spanish}</p>
        </div>
      )}
    </div>
  );
};
